// this is a checkboxes component
// it include the checkboxes button and label
// all the setting is passed in using props
// onChange function is in parent

import React from "react";

const CheckBoxes = (props) => {
  let data = convertData(props.data, props.selectedItem);

  function convertData(ary, selectedItem) {


    if (Array.isArray(ary) && ary.length > 0) {
      let newAry = [];
      for (let i = 0; i < ary.length; i++) {
        let id;
        let label;
        let value;
        let selected;
        let name;
        let activeInd;

        // get id, it can be index(if not found) or type of number or type of string
        if (ary[i].id !== undefined || ary[i].id !== null) {
          if (typeof ary[i].id === "number") {
            id = ary[i].id;
          } else {
            id = ary[i].id.toString();
          }
        } else {
          id = i;
        }

        // get value, can be name, or value
        if (ary[i].value !== undefined) {
          value = ary[i].value;
        } else {
          value = ary[i].name;
        }

        // get label, can be either label or name or value or index
        if (ary[i].label !== undefined) {
          label = ary[i].label;
        } else if (ary[i].name !== undefined) {
          label = ary[i].name;
        } else if (ary[i].value !== undefined) {
          label = ary[i].value;
        } else {
          label = i;
        }

        // compare selectedItem
        // get selected, if not found, set to false
        // check input selectedItem, then check if the json has selected field, all else set to false
        if (true) {
          if (selectedItem !== undefined && selectedItem.length > 0) {
            if (
              selectedItem.find(
                (item) => item.id.toString() === ary[i].id.toString()
              )
            ) {
              selected = true;
            } else {
              selected = false;
            }
          } else if (ary[i].selected !== undefined) {
            selected = ary[i].selected;
          } else {
            selected = false;
          }
        }

        // get name
        if (ary[i].name !== undefined) {
          name = ary[i].name.toString();
        } else {
          name = "";
        }

        // get activeInd
        if (ary[i].activeInd !== undefined) {
          activeInd = ary[i].activeInd;
        } else {
          activeInd = true;
        }

        newAry.push({
          id: id,
          label: label,
          value: value,
          selected: selected,
          name: name,
          activeInd: activeInd
        });
      }

      // on setup, if has selected, return selected, else return []
      //props.value(newAry.filter((item) => item.selected === true));
      return newAry;
    } else {

      // set value to empty array
      //props.value([]);
      return [];
    }
  }

  // default function if not props.onChagne
  // if props onChange or onClick didn't pass in any callback handler
  // run this default function, with console.log
  // else run the props.onChange function.
  function defaultOnChange(event, index, checked) {

    // update data
    data[index].selected = checked;

    if (
      props.onChange === undefined ||
      props.onChange === null ||
      props.value === undefined ||
      props.value === null
    ) {

    } else {
      // return object array to parent
      
      let selectedDataAry = data.filter((item) => item.selected === true)
      let result = props.data.filter(function (o1) {
		    return selectedDataAry.some(function (o2) {
		        return o1.id === o2.id; // return the ones with equal id
		   });
		});
		

      props.value(result);
      props.onChange(result);
    }
  }

  function defaultOnBlur(event, index, checked) {


    if (
      props.onBlur === undefined ||
      props.onBlur === null ||
      props.value === undefined ||
      props.value === null
    ) {

    } else {
      // return object array to parent
      let selectedDataAry = data.filter((item) => item.selected === true)
      let result = props.data.filter(function (o1) {
		    return selectedDataAry.some(function (o2) {
		        return o1.id === o2.id; // return the ones with equal id
		   });
		});
      
      props.value(result);
      props.onChange(result);
    }
  }

  function defaultOnFocus(e) {

    if (props.onFocus !== undefined || props.onFocus !== null) {
      props.onFocus(true);
      //return true;
    }
  }

  // this two function will call then focus on off event fired
  // either calling parent or just do a console.log
  // function focusOnEvent(event) {
  //   if (props.focusOn === undefined || props.focusOn === null) {

  //   } else {
  //     props.focusOn(event);

  //   }
  // }

  // function focusOffEvent(event) {
  //   if (props.focusOff === undefined || props.focusOff === null) {

  //   } else {
  //     props.focusOff(event);

  //   }
  // }

  return (
    <div className="inputbox__container" key={data}>
      <label
        className={`inputbox__label ${
          props.isDisabled ? "inputbox__label--disabled" : ""
        }
      ${props.hasError ? "inputbox__label--error" : ""}     
`}
        style={{
          display:
            props.label === undefined ||
            props.label === null ||
            props.label.length === 0
              ? "none"
              : "block"
        }}
      >
        {props.label}
        <span
          className={`inputbox__required  ${
            props.isRequired
              ? "inputbox__required--show"
              : "inputbox__required--hide"
          }`}
        >
          *
        </span>
      </label>

      <span
        className="inputbox__error"
        style={props.hasError ? {} : { display: "none" }}
      >
        {props.errorMessage}
      </span>

      <div
        className={` ${
          props.layoutVertical ? "container--vertical" : "container--horizontal"
        } `}
        //onFocus={(event) => focusOnEvent(event)}
        //onBlur={(event) => focusOffEvent(event)}
        onFocus={(event) => defaultOnFocus(event)}
        onBlur={(e) => defaultOnBlur(e, e.target.name, e.target.checked)}
        name={"checkboxes_" + props.id}
      >
        {data.map((item, index) => (
          <div className="checkbox__item" key={item.id}>
            <input
              className="checkbox__button"
              type="checkbox"
              id={props.id + "_item_" + item.id}
              name={index} //checkbox does not have index attr, store index value in name attr
              value={item.value}
              onChange={(e) =>
                defaultOnChange(e, e.target.name, e.target.checked)
              }
              //checked={!!item.selected}
              checked={!!data[index].selected}
            />
            <label
              htmlFor={props.id + "_item_" + item.id}
              className="checkbox__label"
            >
              <span>{item.label}</span>
            </label>
          </div>
        ))}
      </div>
      <span className="inputbox__help">{props.helpMessage}</span>
    </div>
  );
};

export default CheckBoxes;
